import { Routes, Route, Navigate } from "react-router-dom";
import SignIn from "../../views/SignIn";
import SignUp from "../../views/SignUp";
import Projects from "../../views/Projects";
import CreateProject from "../../views/CreateProject";
import Logs from "../../views/Logs";
import ProjectView from "../../views/ProjectView";
import ViewSite from "../../ViewSite";
import FileDeployment from "../../views/FileDeployment/";
import Callback from "../../Callback";
import { Box } from "@chakra-ui/react";
import NotFound from "../../views/NotFound";
import CommunityMirrors from "../../views/CommunityMirrors";
import CommunityMirrorView from "../../views/CommunityMirrorView";

function Router() {
  return (
    <Box width="100%" display="flex">
      <Routes>
        <Route path="/" element={<Navigate to="/my-projects" replace />} />
        <Route path="/my-projects" element={<Projects />} />
        <Route path="/logs/:pipelineId" element={<Logs />} />
        <Route path="/my-projects/create" element={<CreateProject />} />
        <Route
          path="/my-projects/:projectId/deploy"
          element={<FileDeployment />}
        />
        <Route path="/my-projects/:projectId" element={<ProjectView />} />
        <Route path="/github/callback" element={<Callback />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/view-site/:url" element={<ViewSite />} />
        <Route path="/project-showcase" element={<CommunityMirrors />} />
        <Route
          path="/project-showcase/:projectId"
          element={<CommunityMirrorView />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Box>
  );
}

export default Router;
